/**
 * Merges `incoming` into `existing` by `id`, replacing matches in place and
 * appending the rest — the paginator's `upsertMany`, minus the entity map.
 */
export const upsertById = <T extends { id: string }>(
  existing: readonly T[],
  incoming: readonly T[]
): T[] => {
  const byId = new Map(existing.map((item) => [item.id, item]));

  incoming.forEach((item) => byId.set(item.id, item));

  return [...byId.values()];
};
